'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _neptune = require('./neptune');

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require('./_n');

var _n3 = _interopRequireDefault(_n2);

var _uson = require('../../node_modules/uson');

var _uson2 = _interopRequireDefault(_uson);

var _engage = require('./engage');

var _engage2 = _interopRequireDefault(_engage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_neptune2.default.engage = _neptune2.default.engage || _engage2.default;

/**
 * surface
 * @SLTWTR
 */
_neptune2.default.surface = {
  direction: 'up',
  position: {},
  scrollPos: 0,
  scrolled: false,
  bottomPos: document.body.getBoundingClientRect().bottom,
  init: function init(p) {
    _neptune2.default.surface.listener(p);
    _neptune2.default.surface.handler(p, false);
  },
  listener: function listener(p) {
    p = p || window;
    p.addEventListener("scroll", _n3.default.debounce(function (e) {
      _neptune2.default.surface.scrolled = true;_neptune2.default.surface.handler(p);
    }));
  },
  handler: function handler(p) {

    p = p || document;
    if (p == window) p = document;

    var b = p;

    if (p == document) b = document.body;
    if (!b) return false;

    var direction = 'down';
    if (b.getBoundingClientRect().top > _neptune2.default.surface.scrollPos && _neptune2.default.surface.scrolled) direction = 'up';

    if (_neptune2.default.surface.direction != direction) {
      _neptune2.default.surface.direction = direction;
      _n3.default.trigger(document, "surface:changeDirection", false, true, {});
    }

    _neptune2.default.surface.scrollPos = b.getBoundingClientRect().top;
    _neptune2.default.surface.position = b.getBoundingClientRect();
    _neptune2.default.surface.emerge(b);
    _neptune2.default.surface.inview(b);
  },
  inview: function inview(p) {},
  emerge: function emerge(p) {

    p == p || window;

    _n3.default.qsa('[neptune-surface]').forEach(function (el) {

      var _surface = [{}];

      if (!!el.getAttribute('neptune-surface')) {
        try {
          _surface = _n3.default.array(_uson2.default.parse(el.getAttribute('neptune-surface')));
        } catch (error) {
          _neptune2.default.debug.error(error, el, 'Surface');
        }
      }

      _surface.forEach(function (o) {

        var trigger = el;
        var offset = 0;

        // console.log('surface',o)

        o.direction = o.direction || 'down';

        if (!!o.trigger && _n3.default.exists(o.trigger)) trigger = _n3.default.qs(o.trigger);

        if (!!o.offset) {
          if (!isNaN(o.offset)) {
            offset = Number(o.offset);
          } else {
            if (o.offset == '_self') offset = _n3.default.height(el); //+ el.getBoundingClientRect()['top']
            if (o.offset == '-_self') offset = -1 * _n3.default.height(el); //+ el.getBoundingClientRect()['top'])
            if (_n3.default.exists(o.offset)) {
              offset = _n3.default.height(_n3.default.qs(o.offset));
              if (window.getComputedStyle(_n3.default.qs(o.offset)).position == 'fixed' && _n3.default.exists(o.offset)) offset += _n3.default.qs(o.offset).getBoundingClientRect()['top'];
              o.targets.forEach(function (t) {
                if (_n3.default.array(t['engage:action'].classes.add).includes('fixed') && _n3.default.exists(o.offset)) offset += _n3.default.qs(o.offset).getBoundingClientRect()['top'];
              });
            }
          }
          // if(!!trigger.getAttribute('data-offset')) offset = trigger.getAttribute('data-offset')
        }

        var delay = o.delay || 0;

        var elementEdge = o.elementEdge || 'top';
        var winEdge = o.windowEdge || 'bottom';

        if (!!o.direction && _neptune2.default.surface.direction != o.direction) return false;

        if (!trigger) return false;
        var elRect = trigger.getBoundingClientRect();

        var winEdgeOffset = 0;
        if (winEdge == 'bottom') winEdgeOffset = document.documentElement.clientHeight;
        if (winEdge == 'bottom') winEdgeOffset = window.innerHeight;

        var targets = o.targets || [{}];
        // console.log(o.direction, winEdge, elementEdge, elRect[elementEdge],(winEdgeOffset + offset))
        if (o.is == 'visible' && elRect.top <= (window.innerHeight || document.documentElement.clientHeight) && elRect.left < (window.innerWidth || document.documentElement.clientWidth)) {
          if (!!o.once && o.once) {
            if (!!el.getAttribute('neptune-surface-once')) return false;
            el.setAttribute('neptune-surface-once', 'once');
          }
          setTimeout(function () {
            _neptune2.default.surface.action(el, targets);
          }, delay);
        } else {

          if (o.direction == 'down' && elRect[elementEdge] <= winEdgeOffset + offset) {

            if (!!o.once && o.once) {
              if (!!el.getAttribute('neptune-surface-once')) return false;
              el.setAttribute('neptune-surface-once', 'once');
            }
            setTimeout(function () {
              _neptune2.default.surface.action(el, targets);
            }, delay);
          }

          if (o.direction == 'up' && elRect[elementEdge] > winEdgeOffset + offset) {
            if (!!o.once && o.once) {
              if (!!el.getAttribute('neptune-surface-once')) return false;
              el.setAttribute('neptune-surface-once', 'once');
            }
            setTimeout(function () {
              _neptune2.default.surface.action(el, targets);
            }, delay);
          }
        }
      });
    });
  },
  action: function action(el, targets) {

    targets.forEach(function (target) {

      _neptune2.default.debug.info('surface:action', { element: el });
      _neptune2.default.debug.info('surface:action', { element: target });

      var targetEl = el;
      if (!!target.selector && _n3.default.exists(target.selector)) targetEl = _n3.default.qs(target.selector);

      if (!!target.selector && target.selector.indexOf('_self') == 0 && target.selector != '_self') targetEl = _n3.default.qs(target.selector.replace('_self ', ''), el);

      if (target.selector && target.selector == '_parent') targetEl = el.parentNode;

      if (!!target.selector && target.selector.indexOf('_parent') == 0 && target.selector != '_parent') targetEl = _n3.default.qs(target.selector.replace('_parent ', ''), el.parentNode);

      if (target.selector && target.selector == '_grandparent') targetEl = el.parentNode.parentNode;

      if (!!target.selector && target.selector.indexOf('_grandparent') == 0 && target.selector != '_grandparent') targetEl = _n3.default.qs(target.selector.replace('_grandparent ', ''), el.parentNode.parentNode);

      if (!!target['engage:action'] && !!_neptune2.default.engage) _neptune2.default.engage.action(targetEl, target['engage:action']);

      if (!!target['periscope:view'] && !!_neptune2.default.periscope) {
        _neptune2.default.periscope.view(targetEl, target['periscope:view'].url);
      }

      if (!!target['liquid:load'] && !!_neptune2.default.liquid) {
        _neptune2.default.liquid.load(target['liquid:load'].topic, target['liquid:load'].data);
      }

      // datalayer support here
    });
  }

};

window.Neptune = _neptune2.default;

exports.default = _neptune2.default.surface;